var shade = null;
var pModalPanel = null; // variable declaration because we need it to be "global"

/**
 * Displays shade
 */
function displayShade(x){
	if (shade !== null){
		shade.destroy();
		shade = null;
	}
	shade =
			new YAHOO.widget.Panel("SHADE",
					{ width:'400px',
				context: ["popup-positioner-400", "tl", "tl"],
				close:false,
				draggable:false,
				zindex: 9204,
				fixedcenter:true,
				modal:true,
				visible:false
					} );
		shade.setBody(x);
		shade.render(document.body);
		shade.show();

}

function hideShade() {
	"use strict";
	if(shade !== null && typeof(shade) !== 'undefined') {
		shade.hide();
	}
}


;
define("legacy/old-shade", function(){});

